module.exports = __webpack_public_path__ + "files/e62f1945d69eef5f2578a20bf679e869.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/favicon-32x32.png
// module id = 569
// module chunks = 60